<template>
    <div class="footer">
        <div class="xian"></div>
        <div class="flex mg">
            <div class="txt">Power by</div>
            <div>
                <img class="img" src="@/assets/img/footer_logo.png" alt="">
            </div>
        </div>
        <div class="xian"></div>
    </div>
</template>

<script>
import { reactive, toRefs, onBeforeMount, onMounted } from 'vue'
import { useRoute, useRouter } from 'vue-router';
export default {
    name: 'index',
    setup() {
        const data = reactive({})
        onBeforeMount(() => {})
        onMounted(() => {})
        return {
            ...toRefs(data),
        }
    },
}

</script>
<style scoped lang='less'>
.footer{
    display: flex;
    align-items: center;
    .xian{
        width: 450px;
        height: 1px;
        background: rgba(0,20,42,0.06);
    }
    .mg{
        margin: 0 12px;
    }
    .flex{
        display: flex;
        align-items: center;
    }
    .txt{
        font-size: 12px;
        font-weight: 400;
        color: #C2C6CA;
        line-height: 22px;
    }
    .img{
        width: 71px;
        height: 16px;
        margin-left: 9px;
        transform: translateY(4px);
    }
}
</style>